import { useTranslation } from 'react-i18next';

export const useGenericCloseBodyText = () => {
  const { t } = useTranslation();

  return t(
    'pb.deleteproductmodal.closeproduct',
    'Are you sure you want to close the product? The product will be removed.',
  );
};
